<script setup lang="ts">
import ArchetypeCallout from './ArchetypeCallout.vue';
import ArchetypeCta from './ArchetypeCta.vue';
import ArchetypeHero from './ArchetypeHero.vue';
import ArchetypeRelatedLinks from './ArchetypeRelatedLinks.vue';
import ArchetypeSection from './ArchetypeSection.vue';
import ArchetypeSteps from './ArchetypeSteps.vue';

type HeroBlock = {
  eyebrow?: string;
  title: string;
  summary: string;
  cta?: { label: string; to: string };
};

type SectionBlock = {
  title: string;
  content?: string;
  items?: { title: string; description: string }[];
};

type StepBlock = {
  title: string;
  description: string;
};

type CalloutBlock = {
  title: string;
  content: string;
  tone?: 'info' | 'boundary';
};

type LinkBlock = {
  label: string;
  description: string;
  to: string;
};

defineProps<{
  hero: HeroBlock;
  intro?: SectionBlock;
  sections?: SectionBlock[];
  steps?: { title: string; items: StepBlock[] };
  callout?: CalloutBlock;
  relatedLinks?: { title: string; items: LinkBlock[] };
  cta?: { title: string; content: string; label: string; to: string };
}>();
</script>

<template>
  <div class="bg-slate-50">
    <ArchetypeHero v-bind="hero" />

    <div class="mx-auto max-w-6xl px-4 py-12 sm:px-6 sm:py-16 lg:px-8">
      <ArchetypeSection
        v-if="intro"
        :title="intro.title"
        :content="intro.content"
        :items="intro.items"
      />

      <ArchetypeSteps
        v-if="steps"
        :title="steps.title"
        :items="steps.items"
      />

      <div
        v-if="sections?.length"
        class="mt-12 grid gap-6 lg:grid-cols-2"
      >
        <ArchetypeSection
          v-for="section in sections"
          :key="section.title"
          :title="section.title"
          :content="section.content"
          :items="section.items"
          compact
        />
      </div>

      <ArchetypeRelatedLinks
        v-if="relatedLinks"
        class="mt-12"
        v-bind="relatedLinks"
      />

      <ArchetypeCta
        v-if="cta"
        class="mt-12"
        v-bind="cta"
      />

      <ArchetypeCallout
        v-if="callout"
        class="mt-12"
        v-bind="callout"
      />
    </div>
  </div>
</template>
